import React, { FC, useCallback, useEffect, useMemo, useState } from "react"
import { Button, Image, Mask, SafeArea, Tabs, Toast } from "antd-mobile"
import { Popup } from "antd-mobile/2x"
import { useNavigate, useParams } from "react-router-dom"
import { useGetWelfareRid } from "~src/hooks/useGetWelfareRid"
import { getResidualIntegral, getWelfareDetail, getWelfareParticipation, postExchange } from "~src/service/welfare"
import styles from "./index.module.less"
import { WelfareDetailType, WelfareMoldTyp, WelfareVosType } from "~src/service/welfare/welfare"
import WelfareTitle from "./WelfareTitle"
import WelfareAbout from "./WelfareAbout"
import { carbon_titlebg, huanbao_titlebg, humanity_titlebg, certification_title_img, arrow_right } from "~src/constants/network"
import { useThrottleFn } from "ahooks"
import Welfarekake from "./Welfarekake"
import WelfareParticipant from "./WelfareParticipant"
import classNames from "classnames"
import MockContent from "../components/MockContent"
import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { setShare } from "~src/hooks/useShare"

enum WelfareSeatType {
  "INTRODUCE" = "introduce",
  "RULE" = "rule"
}
interface WelfareColorType {
  backgroundColor: string,
  color: string
  titleSrc: string
}
enum CertificationType {
  'CERTIFICATE' = 'certificate',
  'PARTICIPANT' = 'participant'
}
type WelfareDetailsColorType = Record<WelfareMoldTyp, WelfareColorType>

const dev = process.env.NODE_ENV == "development" ? "-dev" : "";

const WelfareDetails: FC = () => {
  const { id = "" } = useParams()
  useDocumentTitle("公益详情")
  const [detail, setDetail] = useState<WelfareDetailType>({} as WelfareDetailType);
  const [rid, setRid] = useState<string>("")
  const [point, setPoint] = useState<string>("0")
  const [visibleMask, setVisibleMask] = useState<boolean>(false)
  const [welfareSrc, setWelfareSrc] = useState<string>("")
  const [activeKey, setActiveKey] = useState<string>('1')
  const [showTags, setShowTags] = useState<boolean>(false)
  const [vos, setVos] = useState<WelfareVosType>({} as WelfareVosType)
  const [pack, setPack] = useState<boolean>(false)
  const [visible, setVisible] = useState<boolean>(false)
  const tabItems = [
    { key: '1', title: "项目介绍" },
    { key: '3', title: '参与规则' },
    { key: '4', title: '参与记录' },
  ]
  const tabHeight = 100
  const navigate = useNavigate()

  const WelfareColor: WelfareDetailsColorType = useMemo(() => {
    return {
      "1": {
        backgroundColor: "#E9FBEE",
        color: "#23D85A",
        titleSrc: carbon_titlebg
      },
      "2": {
        backgroundColor: "#EBF3FF",
        color: "#3B8BFF",
        titleSrc: huanbao_titlebg
      },
      "3": {
        backgroundColor: "#FEFBEC",
        color: "#F7D441",
        titleSrc: humanity_titlebg
      }
    }
  }, [])
  const detailTitle = useMemo(() => {
    return {
      backgroundImage: `url(${WelfareColor[String(detail.categoryId) as WelfareMoldTyp]?.titleSrc})`
    }
  }, [WelfareColor, detail.categoryId])
  const introduce = useMemo(() => {
    return {
      border: `1px solid ${WelfareColor[String(detail.categoryId) as WelfareMoldTyp]?.color}`,
      boxShadow: `6px 6px 0px ${WelfareColor[String(detail.categoryId) as WelfareMoldTyp]?.color}`

    }
  }, [WelfareColor, detail.categoryId])
  const ruler = useMemo(() => {
    return {
      border: `1px solid ${WelfareColor[String(detail.categoryId) as WelfareMoldTyp]?.color}`,
    }
  }, [WelfareColor, detail.categoryId])
  const itemTag = useMemo(() => {
    return {
      backgroundColor: WelfareColor[String(detail.categoryId) as WelfareMoldTyp]?.color
    }
  }, [WelfareColor, detail.categoryId])
  const tagColor = useMemo(() => {
    return {
      "--active-line-color": WelfareColor[String(detail.categoryId) as WelfareMoldTyp]?.color,
      "--active-title-color": WelfareColor[String(detail.categoryId) as WelfareMoldTyp]?.color,
    }
  }, [WelfareColor, detail.categoryId])
  const getWelfareDetailData = async (rid: string) => {
    const data = await getWelfareDetail(rid, { skuId: id })
    setDetail(data)
    setShare([
      {
        showGoHomeButton: true,
        shareMiniProgramPath: "/pages/load_bearing/new_webview/index?url=" + encodeURIComponent(`${window.location.origin}${window.location.pathname}`) + "&type=token",
        shareDesc: data.summary,
        shareTitle: data.name,
      }
    ]);
  }
  const getWelfareParticipationList = useCallback(async (rid: string) => {
    const data = await getWelfareParticipation(rid, { skuId: id })
    setVos(data)
  }, [id])
  useGetWelfareRid((rid) => {
    setRid(() => rid)
    getPoint(rid)
    getWelfareDetailData(rid)
    getWelfareParticipationList(rid)
  }, [])
  const { run: handleScroll } = useThrottleFn(
    (e) => {
      let currentKey = tabItems[0].key;
      for (const item of tabItems) {
        const element = document.getElementById(`anchor-${item.key}`)
        if (!element) continue
        const rect = element.getBoundingClientRect()
        if (rect.top <= tabHeight) {
          currentKey = item.key
        } else {
          break
        }
      }
      setActiveKey(currentKey)
    },
    {
      leading: true,
      trailing: true,
      wait: 100,
    }
  )
  const { run: bindScroll } = useThrottleFn(
    () => {
      const element = document.getElementById(`anchor-1`)
      const rect = element?.getBoundingClientRect() as DOMRect
      rect?.top <= tabHeight ? setShowTags(true) : setShowTags(false)
    },
    {
      leading: true,
      trailing: true,
      wait: 100,
    }
  )
  const getPoint = useCallback(async (rid: string) => {
    setPoint(await getResidualIntegral(rid))
  }, [])
  const onExchange = useCallback(async () => {
    setPoint(await getResidualIntegral(rid))
    setVisible(true)
  }, [rid])
  const onExchangeWelfare = useCallback(async () => {
    try {
      if (Number(point) < detail.priceFee) {
        Toast.show(`${detail.priceUnit}不足`)
        return;
      }
      const data = await postExchange(rid, { skuId: String(detail.skuId) })
      if (data) {
        setWelfareSrc(data)
        setVisibleMask(true)
        setVisible(false)
        getWelfareParticipationList(rid)
      }
    } catch (error) { /* empty */ }
  }, [point, detail.priceFee, detail.skuId, detail.priceUnit, rid, getWelfareParticipationList])
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])
  useEffect(() => {
    window.addEventListener('scroll', bindScroll)
    return () => {
      window.removeEventListener('scroll', bindScroll)
    }
  }, [bindScroll])

  const onViewCertification = useCallback((type: CertificationType) => {
    if (type === CertificationType.CERTIFICATE) {
      navigate(`/welfare/blockchain?id=${detail.spuId}`)
    } else if (type === CertificationType.PARTICIPANT) {
      navigate(`/welfare/records?spuId=${detail.spuId}&skuId=${detail.skuId}&name=${detail.name}&categoryId=${detail.categoryId}`)
    }
  }, [detail])

  const goToBlockChain = (id: string) => {
    navigate(`/welfare/blockchain?id=${id}&type=participant`)
  }

  return <div className={styles.detail}
    style={{ backgroundColor: `${detail && WelfareColor[String(detail?.categoryId) as WelfareMoldTyp]?.backgroundColor}`, }} >
    <Image className={styles["detail-mainImg"]} src={detail.mainImgUrl}></Image>
    <div className={styles["detail-title"]} style={detailTitle}>
      <div className={styles["detail-title-name"]}>{detail.name}</div>
      <div className={styles["detail-title-tag"]}>
        {
          detail.tagList?.map((item, index) => {
            return <span className={styles["detail-title-tag-item"]} style={itemTag} key={index}>{item}</span>
          })
        }
      </div>
      <div className={styles["detail-title-desc"]}> {detail.summary}</div>
    </div>
    <Tabs
      className={styles.tags}
      activeKey={activeKey}
      style={{ ...tagColor, visibility: showTags ? 'visible' : 'hidden' }}
      onChange={key => {
        document.getElementById(`anchor-${key}`)?.scrollIntoView()
        window.scrollTo({
          top: window.scrollY - tabHeight,
          behavior: 'smooth'
        })
      }}>
      {tabItems.map(item => (
        <Tabs.Tab title={item.title} key={item.key} />
      ))}
    </Tabs>
    <div className={styles["detail-body"]}  >
      <div id={`anchor-1`}>
        <WelfareTitle type={detail.categoryId as WelfareMoldTyp} seat={WelfareSeatType.INTRODUCE} />
        <div className={classNames(styles.introduce, styles["introduce-out"], pack && styles["introduce-in"])} style={introduce} >
          <div className={styles["introduce-detail"]} dangerouslySetInnerHTML={{ __html: detail.detail }}></div>
          <div className={styles["introduce-pack"]} onClick={() => { setPack(!pack) }}>
            <span>{pack ? "收起全部" : "展开全部"}</span>
            <span className={classNames("iconfont", styles["introduce-pack-arrow"])}>&#xe61e;</span>
          </div>
        </div>
      </div>
      <div id={`anchor-2`} className={styles.certificatewrap} style={{ display: detail.isOnChain === 1 ? "block" : 'none' }}>
        <Welfarekake type={detail.categoryId as WelfareMoldTyp} title="支持凭证" />
        <div className={classNames(styles.certification, pack && styles["introduce-in"])} style={introduce} >
          <div>
            <Image src={certification_title_img} className={styles["certification-titleicon"]} fit="contain" />
            <Image src={detail.certificationImg} className={styles["certification-certificationicon"]} />
          </div>
          <div className={styles["certification-pack"]} onClick={onViewCertification.bind(this, CertificationType.CERTIFICATE)}>
            <span>查看区块链电子存证</span>
            <Image className={styles["certification-pack-arrow"]} src={arrow_right} />
          </div>
        </div>
      </div>
      <div id={`anchor-3`}>
        <WelfareTitle type={detail.categoryId as WelfareMoldTyp} seat={WelfareSeatType.RULE} />
        <div className={styles.ruler} style={ruler}>
          <div dangerouslySetInnerHTML={{ __html: detail.ruler }}></div>
        </div>
      </div>
      <div id={`anchor-4`}>
        <Welfarekake type={detail.categoryId as WelfareMoldTyp} />
        <WelfareParticipant name={detail.name} type={detail.categoryId as WelfareMoldTyp} vos={vos} isOnChain={detail.isOnChain} onClick={onViewCertification.bind(this, CertificationType.PARTICIPANT)} goToBlockChain={goToBlockChain} />
      </div>
      <WelfareAbout type={detail.categoryId as WelfareMoldTyp} />
      <div className={styles.aboutCont}>
        <div dangerouslySetInnerHTML={{ __html: detail.about }}></div>
      </div>
    </div>
    <div className={styles.mock}>
      <Button
        loading="auto"
        loadingText="兑换中"
        className={styles["mock-boby-btn"]}
        style={{
          "--background-color": "#F4C500",
          "--border-color": "#F4C500",
          "--text-color": "#FFFFFF",
        }}
        onClick={onExchange}
        block shape='rounded' >
        <span>兑换证书</span>
      </Button>
      <SafeArea position='bottom' />
    </div>
    <SafeArea position='bottom' />
    <Mask visible={visibleMask} onMaskClick={() => setVisibleMask(false)}>
      <div className={styles.mask}>
        <img className={styles["mask-content"]} src={welfareSrc} alt="" />
        <div className={styles["mask-close"]}>
          <span onClick={() => setVisibleMask(false)} className={classNames("iconfont", styles["mask-close-btn"])}>&#xe61c;</span>
        </div>
      </div>
    </Mask>
    <Popup
      visible={visible}
      showCloseButton
      onClose={() => {
        setVisible(false)
      }}
      onMaskClick={() => {
        setVisible(false)
      }}
      bodyStyle={{
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        minHeight: '30vh',
      }}>
      <MockContent point={point} item={detail} onExchange={onExchangeWelfare} />
    </Popup>
  </div>
}
export default WelfareDetails
